import { gql } from 'apollo-angular';

export const GET_GATEWAY_FROM_SETTLEMENT_ACCOUNT = gql`
  query GetSettlementAccountsType($merchantId: String, $businessId: String) {
    GetSettlementAccountsType(
      merchantId: $merchantId
      businessId: $businessId
    ) {
      accountType
      businessId
    }
  }
`;
